module.exports = __webpack_public_path__ + "img/SKWINKELNetActieDoelstellingenE2A637.723094de.png";